import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useBreakpointValue,
} from "@chakra-ui/react";
import { useMotionValueEvent, useScroll } from "framer-motion";
import { useState } from "react";
import { useUserData } from "@/contexts/UserDataContext";
import { HSCreateAccount, MultiMethodAuth } from "./CreateAccount";

const ModalAuth = ({ header, open, onClose, onComplete, ...rest }) => {
  return (
    <Modal isOpen={open} onClose={onClose} size="md" {...rest}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader p={8} fontSize="3xl" fontFamily="heading" textAlign="center">
          {header}
        </ModalHeader>
        <ModalBody pb={10}>
          <HSCreateAccount onComplete={onComplete} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export const ScrollAuthWall = ({
  base,
  md,
  header = "To keep viewing these opportunities, create a free account with us.",
}) => {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const { currentUser } = useUserData();
  const authWallY = useBreakpointValue({ base, md });
  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, "change", (latest) => {
    setShowAuthModal(latest > authWallY && !currentUser);
  });
  return (
    <ModalAuth
      header={header}
      size="lg"
      open={showAuthModal}
      onClose={() => setShowAuthModal(true)}
      onComplete={() => setShowAuthModal(false)}
    />
  );
};

export default ModalAuth;
